export function getBrand() {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("ctx")) {
    return "ctx";
  } else if (hostname.includes("mithub")) {
    return "mithub";
  }
  return "default";
}
